import Breadcrumbs from "@mui/material/Breadcrumbs";
import { FastLink } from "../pages/Profile/Profile.styles";

const FastBreadcrumbs = ({ links }: any) => {
  const breadcrumbs = links.map((el: any, index: number) => {
    if (index === links.length - 1) {
      return (
        <FastLink key={index} $current>
          {el.name}
        </FastLink>
      );
    }
    return <FastLink key={index}>Главная</FastLink>;
  });
  return (
    <Breadcrumbs
      separator=">"
      aria-label="breadcrumb"
      sx={{ pt: "10px" }}
      className="bread-crumbs">
      {breadcrumbs}
    </Breadcrumbs>
  );
};

export default FastBreadcrumbs;
